import AuthManager from './AuthManager'

// returns an authenticated fetch requests if possible
// these method are just shortcuts for including headers into
// fetch requests
const PAGE_LIMIT = 20
export default class FetchHelper {
  static get(endpoint, validateTokens = true) {
    let data = {}
    data['headers'] = AuthManager.getHeaders()
    let statusCode = null
    return FetchHelper._handleValidateTokens(validateTokens).then(() => {
      return fetch(endpoint, data)
        .then((response) => {
          statusCode = response.status
          return response.json()
        })
        .then((responseJson) => {
          let status = { code: statusCode, success: responseJson.status }
          if (this._hasError(status)) {
            throw FetchHelper._getError(responseJson)
            return
          }

          return responseJson
        })
    })
  }

  static getPaginated(
    endpoint,
    page,
    validateTokens = true,
    pageLimit = PAGE_LIMIT
  ) {
    if (endpoint.includes('?')) {
      endpoint += '&'
    } else {
      endpoint += '?'
    }
    return FetchHelper._handleValidateTokens(validateTokens).then(() => {
      return FetchHelper.get(endpoint + 'page=' + page).then((responseJson) => {
        return responseJson
      })
    })
  }

  static post(endpoint, data, isMultiPart = false, validateTokens = true) {
    let statusCode = null
    return FetchHelper._handleValidateTokens(validateTokens).then(() => {
      return fetch(endpoint, {
        method: 'POST',
        headers: isMultiPart
          ? AuthManager.getHeaders('multipart/form-data', validateTokens)
          : AuthManager.getHeaders(),
        body: isMultiPart ? data : JSON.stringify(data),
      })
        .then((response) => {
          statusCode = response.status
          if (statusCode == 204) {
            return response
          }
          return response.json()
        })
        .then((responseJson) => {
          let status = { code: statusCode, success: responseJson.status }
          if (this._hasError(status)) {
            throw FetchHelper._getError(responseJson)
            return
          }
          return responseJson
        })
    })
  }

  static _handleValidateTokens(validateTokens) {
    return new Promise((resolve, reject) => {
      if (validateTokens) {
        return AuthManager.validateTokens(resolve, reject)
      }
      resolve()
    })
  }

  static patch(endpoint, data, stringify = true, validateTokens = true) {
    var headers = AuthManager.getHeaders()
    if (stringify) {
      data = JSON.stringify(data)
    } else {
      headers = AuthManager.getHeaders('multipart/form-data')
    }

    let statusCode = null
    return FetchHelper._handleValidateTokens(validateTokens).then(() => {
      return fetch(endpoint, {
        method: 'PATCH',
        headers: headers,
        body: data,
      })
        .then((response) => {
          statusCode = response.status
          if (statusCode == 204) {
            return response
          }
          return response.json()
        })
        .then((responseJson) => {
          let status = { code: statusCode, success: responseJson.status }
          if (this._hasError(status)) {
            throw FetchHelper._getError(responseJson)
          }
          return responseJson
        })
    })
  }

  static put(
    endpoint,
    data,
    stringify = true,
    validateTokens = true,
    parseResponse = true
  ) {
    var headers = AuthManager.getHeaders()

    if (stringify) {
      data = JSON.stringify(data)
    } else {
      headers = AuthManager.getHeaders('multipart/form-data', validateTokens)
    }

    let statusCode = null
    return FetchHelper._handleValidateTokens(validateTokens).then(() => {
      return fetch(endpoint, {
        // this is needed by server side for all put requests
        method: 'PUT',
        headers: headers,
        body: data,
      })
        .then((response) => {
          statusCode = response.status
          if (!parseResponse) {
            return response
          }
          return response.json()
        })
        .then((responseJson) => {
          let status = { code: statusCode, success: responseJson.status }
          if (this._hasError(status)) {
            throw FetchHelper._getError(responseJson)
          }

          return responseJson
        })
    })
  }

  static delete(endpoint, data, validateTokens = true) {
    let statusCode = null
    return FetchHelper._handleValidateTokens(validateTokens).then(() => {
      return fetch(endpoint, {
        method: 'DELETE',
        headers: AuthManager.getHeaders(),
        body: JSON.stringify(data),
      })
        .then((response) => {
          statusCode = response.status
          if (statusCode == 204) {
            return response
          }
          return response.json()
        })
        .then((responseJson) => {
          let status = { code: statusCode, success: responseJson.status }
          if (this._hasError(status)) {
            throw FetchHelper._getError(responseJson)
            return
          }
          return responseJson
        })
    })
  }

  static download(endpoint, filename, validateTokens = true) {
    let data = {}
    data['headers'] = AuthManager.getHeaders()
    let statusCode = null
    return FetchHelper._handleValidateTokens(validateTokens).then(() => {
      return fetch(endpoint, data)
        .then((response) => {
          statusCode = response.status
          return response.blob()
        })
        .then((responseBlob) => {
          let status = { code: statusCode, success: responseBlob.status }
          if (this._hasError(status)) {
            throw FetchHelper._getError(responseBlob)
            return
          }

          return responseBlob
        })
        .then((data) => {
          var link = document.createElement('a')
          link.href = window.URL.createObjectURL(data)
          link.download = filename
          link.click()
        })
    })
  }

  static _hasError({ code, success }) {
    return code < 200 || code > 299 || success == false
  }

  static _getError(responseJson, appendKeys) {
    let error = null

    if (responseJson.message) {
      error = responseJson.message
    } else if (responseJson.non_field_errors) {
      return {
        error: responseJson.non_field_errors[0],
        message: responseJson.non_field_errors[0],
      }
    } else {
      error = responseJson
    }

    if (error.constructor == Object) {
      for (var key in error) {
        error =
          key +
          ': ' +
          FetchHelper._getError(error[Object.keys(error)[0]]).message
        break
      }
    }

    if (error instanceof Array) {
      let index = 1
      for (var key in error) {
        if (
          error[key] &&
          error[key].constructor === Object &&
          Object.keys(error[key]).length
        ) {
          error = '#' + index + ': ' + FetchHelper._getError(error[key]).message
          break
        }
        index++
      }
    }

    let message = 'An unexpected error occured'

    if (typeof error === 'string') {
      message = error
    }
    if (error.constructor == Object) {
      for (key in error) {
        message = error[key]
      }
    }
    if (error instanceof Array) {
      message = error[0]
    }

    let errorObject = { error: error, message: message }

    if (typeof responseJson === 'object') {
      for (key in responseJson) {
        if (key !== 'message' || key !== 'error') {
          errorObject[key] = responseJson[key]
        }
      }
    }

    return errorObject
  }

  static _hasMore(results, pageLimit) {
    if (results.current_page) {
      return results.current_page < results.last_page
    }
    return results.data.length >= pageLimit
  }
}
